(() => {
  'use strict';
  const root = document.querySelector('[data-fp-theme]');
  const ask = root?.querySelector('[data-theme-ask]');
  if (!ask || !document.querySelector('[data-fp-assistant]')) return;
  ask.hidden = false;
  ask.setAttribute('aria-label', window.FivePointI18n.t("Refine {{p0}} with Ask FivePoint", [root.dataset.title]));
  ask.addEventListener('click', () => {
    const edits = [...root.querySelectorAll('[data-theme-edit-title]')].map(el => el.dataset.themeEditTitle).join(', ');
    document.dispatchEvent(new CustomEvent('fivepoint:assistant-compose', { detail: {
      text: window.FivePointI18n.t("I'm exploring the \"{{p0}}\" theme and its fabric edits: {{p1}}. Help me refine these fabrics for my project: ", [root.dataset.title, edits]),
      trigger: ask
    } }));
  });
  new IntersectionObserver(entries => {
    document.body.classList.toggle('fp-theme-cta-visible', entries[0].isIntersecting);
  }, { threshold: 0.5 }).observe(ask);
})();
